import React from 'react'
import FreelancerProfileComp from '../../components/freelancer/Profile'

export default function ShowFreelancer() {
  return (
    <FreelancerProfileComp />
  )
}
